import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {size} from 'underscore';

import {changeSetting} from 'common/actions/settings';
import {getActiveAgency, getActiveAgencyId, getAgencies} from 'ondemand/selectors';
import {fetchAgenciesIfNeeded} from 'ondemand/actions/agency';
import AgencyPickerModal from 'ondemand/components/AgencyPickerModal';

class AgencyPicker extends React.Component {
  static displayName = 'AgencyPicker';

  static propTypes = {
    agency: PropTypes.object,
    agencyId: PropTypes.string,
    agencies: PropTypes.object,
    dispatch: PropTypes.func,
  };

  componentDidMount() {
    this.props.dispatch(fetchAgenciesIfNeeded())
      .then(() => {
        if (this.props.agencyId !== null && !this.props.agency) {
          this.props.dispatch(changeSetting('agencyId', null));
        }
      });
  }

  _handleAgencyClick = (agency) => {
    this.props.dispatch(changeSetting('agencyId', agency.agencyId));
  };

  render() {
    return (
      <AgencyPickerModal
        agencies={this.props.agencies}
        dataId={'agency-select-modal-container'}
        onAgencyClick={this._handleAgencyClick}
        open={!!size(this.props.agencies) && !this.props.agency}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  agencies: getAgencies(state),
  agency: getActiveAgency(state),
  agencyId: getActiveAgencyId(state),
});

export default connect(mapStateToProps)(AgencyPicker);



// WEBPACK FOOTER //
// ./src/ondemand/containers/AgencyPicker.js